'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var locale = {
  placeholder: 'Izaberite vreme'
};

exports['default'] = locale;